import { createContext } from 'react';

import type { SplitDetailPanelContextValue } from '../provider/SplitDetailPanelProvider';

export const SplitDetailPanelStoreContext = createContext<SplitDetailPanelContextValue | null>(
  null,
);

// Re-export type for backwards compatibility
export type { SplitDetailPanelContextValue };
